import React, { SVGProps } from "react";

export const ZapFastIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    {...props}
  >
    <path
      d="M18 35H7M13 24H4M18 13H8M34 6L20.8071 24.47C20.2232 25.2875 19.9312 25.6963 19.9439 26.0371C19.9549 26.3338 20.0972 26.6102 20.3322 26.7916C20.6022 27 21.1045 27 22.1091 27H32L30 42L43.1929 23.53C43.7768 22.7125 44.0688 22.3037 44.0561 21.9629C44.0451 21.6662 43.9028 21.3898 43.6678 21.2084C43.3978 21 42.8955 21 41.8909 21H32L34 6Z"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
